export default __webpack_public_path__ + "static/media/VICE_PRINCIPAL.9a188039.jpg";